module.exports = __webpack_public_path__ + "img/logo-gray.91fd000e.svg";